import stateFactory from './state'
import * as helpers from '@/store/helpers'
import {
	ADD_ITEMS,
	RESET,
	SET_EXTERNAL_PROVIDERS,
	SET_INTERNAL_PROVIDERS,
} from '@/store/mutation-types'

/**
 * The module's state mutators.
 *
 * @author Alejandro Sanchez <asanchez@claruscare.com>
 */
export default {
	/**
	 * Add the given model(s) to the store.
	 *
	 * @param {Object} state
	 * @param {Array} models
	 */
	[ADD_ITEMS](state, models) {
		helpers.add(state, models)
	},

	/**
	 * Set the store's external provider ids.
	 *
	 * @param {Object} state
	 * @param {Array} ids
	 */
	[SET_EXTERNAL_PROVIDERS](state, ids) {
		state.external = ids
	},

	/**
	 * Set the store's internal provider ids.
	 *
	 * @param {Object} state
	 * @param {Array} ids
	 */
	[SET_INTERNAL_PROVIDERS](state, ids) {
		state.internal = ids
	},

	/**
	 * Reset the given state back to its original value.
	 *
	 * @param {Object} state
	 * @return {void}
	 */
	[RESET](state) {
		helpers.reset(state, stateFactory())
	},
}
